import { Link } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()(() => ({
    link: {
        cursor: "pointer",
        color: "inherit",
        textAlign: "left",
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline",
        },
    },
}))

type TableNameLinkProps = Readonly<{
    name: string
    onClick: () => void
}>

export function TableNameLink({ name, onClick }: TableNameLinkProps): JSX.Element {
    const { classes } = useStyles()

    return (
        <Link component="button" type="button" variant="body2" className={classes.link} onClick={onClick}>
            {name}
        </Link>
    )
}
